import React from 'react';
import './style.scss';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../Shared/components/controls/Button';

const AccordionDescription = ({ title, text, link }) => {
  const needTitle = title?.value;
  const needText = text?.value;
  const needLink = link?.value?.href;

  if (!needTitle && !needText && !needLink) return null;

  return (
    <div className="accordion-component-description">
      {needTitle && (
        <div className="ac-desc-title">
          <Text field={title} />
        </div>
      )}
      {needText && <RichText className="ac-desc-text" field={text} />}
      {needLink && <Button link={link} arrow="left" variant="text" />}
    </div>
  );
};

export default AccordionDescription;
